module.exports = __webpack_public_path__ + "img/OverseaMember71.786efa33.png";